import { CARD_LIST_IN_STORE_TEST_IDS } from '@susu/custom-made/utils/testIds';
import { onEnter } from '@susu/custom-made/utils/utils';

export default function CardListInStore({
  scanClick,
}: Readonly<{
  scanClick: () => void;
}>) {
  return (
    <>
      <div
        className="cursor-pointer pb-38 md:pb-[41px] lg:hidden"
        data-testid={CARD_LIST_IN_STORE_TEST_IDS.SCAN_CARD}
        onClick={scanClick}
        onKeyDown={e => {
          onEnter(e, () => {
            scanClick();
          });
        }}
      >
        <div className="w-44 h-[78px] border border-gray-400 flex justify-center items-center shrink-0 m-3 rounded-md cursor-pointer [&>i]:w-20 [&>i]:h-20 [&>i]:p-0 [&>i]:text-xl md:w-60 md:h-[110px] md:m-5 md:[&>i]:w-24 md:[&>i]:h-24 md:[&>i]:text-2xl">
          <i className="susu-icons" translate="no">
            scan
          </i>
        </div>
      </div>
    </>
  );
}
